import { DataLogin } from './autenticacion.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

export enum ESTADOS_PAGO {
  PENDIENTE = 'Pendiente',
  VERIFICADO = 'Exitoso',
  VERIFICAR = 'Verificar'
}

import { environment } from 'src/environments/environment';

const smartHomeUrl = environment.smartHomeUrl;
@Injectable({
  providedIn: 'root'
})
export class PagosService {  

  constructor(
    private _http: HttpClient
  ) { }

  public detallePago = new BehaviorSubject(null);
  public mostrarModalCargarPagos = new BehaviorSubject(false);

  public cambiarDetallePago(detallePago: number): void {
    this.detallePago.next(detallePago);
  }

  public cambiarMostrarModalCargarPagos(nuevoMostrarModalCargarPagos: boolean): void {
    this.mostrarModalCargarPagos.next(nuevoMostrarModalCargarPagos);
  }

  traerPagosUnidad(page: number, palabrasClave: string, estado: number, fechaInicio: number, fechaFinal: number) {
    const requestUrl = `${smartHomeUrl}api/pagos?status=${estado}&key=${palabrasClave}&page=${page + 1}&cant=8&date_begin=${fechaInicio}&date_end=${fechaFinal}`;
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));

    const headers = new HttpHeaders({
      unidadId: String(loginData.company_id),
    });

    return <Observable<RespuestaPagos>>this._http.get(requestUrl, { headers });
  }

  traerDetallePago(idPago: number) {
    const requestUrl = `${smartHomeUrl}api/pagos/pago/${idPago}`;

    const headers = new HttpHeaders({
      dataPago: "true"
    });

    return <Observable<RespuestaPago>>this._http.get(requestUrl, { headers });
  }

  verificarPago(idPago: number) {
    const requestUrl = `${smartHomeUrl}api/pagos/comprobante`;

    const body = {
      id: idPago,
      status_payment: ESTADOS_PAGO.VERIFICADO,
      status: 0
    };

    return <Observable<RespuestaPago>>this._http.patch(requestUrl, body);
  }

  cargarPagos(archivo: File) {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));
    const requestUrl = `${smartHomeUrl}api/unidades/unidad/${loginData.company_id}`;

    const headers = new HttpHeaders({
      dataUploadPagos: "true"
    });

    const formData = new FormData();
    formData.append('pagos', archivo);

    return <Observable<RespuestaCargaPagos>>this._http.patch(requestUrl, formData, { headers });
  }
}

export interface RespuestaCargaPagos {
  data: {
    csvP: {
      record: [],
      message: [],
      inser: number,
      update: number,
      error: number
    }
  }
}


export interface RespuestaPago {
  data: {
    data_pago: Pago
  }
}

export interface RespuestaPagos {
  data: {
    pagos: Pago[]
  }
}

export interface Pago {
  id: number;
  place_id: number;
  type_charge: string;
  value: number;
  date: number;
  type_payment: string;
  status_payment: string;
  status: number;
  site_name: string;
  area_name: string;
  user_name: string;
  user_lastname: string;
  voucher?: string;
}